import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import qs from 'qs'
import {ACCESS_TOKEN, APP_TOKEN, USER_TOKEN} from '../store/mutation-types'
import router from '../router'
import HttpConfig from '../request/HttpConfig.js'
import CommonContentType from '../request/CommonContentType.js'
import HttpCode from '../request/HttpCode.js'
import {getToken} from '../utils/auth'


var isShowLogger = false

// debugger
axios.defaults.timeout = 0
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest',
  [CommonContentType._CONTENT_TYPE_KEY]: CommonContentType._APPLICATION.JSON
}
axios.defaults.responseType = 'json'


var common = axios.create()

var instance = axios.create({// post 常规请求
  headers: {
    [CommonContentType._CONTENT_TYPE_KEY]: CommonContentType._MULTIPART.FORM_DATA
  }
})

var json = axios.create({ // post json
  headers: {
    [CommonContentType._CONTENT_TYPE_KEY]: CommonContentType._APPLICATION.JSON
  }
})

var down = axios.create({ // 文件下载
  headers: {
    [CommonContentType._CONTENT_TYPE_KEY]: CommonContentType._APPLICATION.JSON
  },
})

var _IS_SHOW_TIP = true

// 初始化参数
let initConfig = (config) => {
  // logger.info('http--initConfig:', config)
  if (config.url.indexOf('/login/myLoginForm') <= 0) {
    // TODO 加线上对接 header
    // const token = localStorage.getItem(ACCESS_TOKEN)
    const token = 'Bearer ' + getToken()// 暂时处理
    if (token) {
      config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
      config.headers.BrowserHeader = 'H5'
    }
    if (process.env.VUE_APP_BB_IP === 'open') {
      const userToken = localStorage.getItem(USER_TOKEN)
      if (userToken) {
        config.headers['token'] = userToken // 让每个请求携带自定义 token 请根据实际情况自行修改
      }
      const appToken = localStorage.getItem(APP_TOKEN)
      if (appToken) {
        config.headers['appToken'] = appToken // 让每个请求携带自定义 token 请根据实际情况自行修改
      }
    }
  }
  // config.headers.userInfo = user.getHeaderUser()

  config.cancelToken = new axios.CancelToken(cancle => {
    if (!window._axiosPromiseArr) {
      window._axiosPromiseArr = []
    }
    let _key = HttpConfig._TYPE.CANCLE_DEFAULT
    if (config[HttpConfig._TYPE.CANCLE_KEY]) {
      _key = config[HttpConfig._TYPE.CANCLE_KEY]
    }
    window._axiosPromiseArr.push({
      key: _key,
      cancle: cancle
    })
    // window._axiosPromiseArr.push({cancel})
    // logger.info('cancel', cancle)
    // logger.info('_axiosPromiseArr', window._axiosPromiseArr)
  })
  // 判断当前请求是否设置了不显示Loading,默认显示
  if (config[HttpConfig._TYPE.LOADING] !== false) {
    // showLoading(config[HttpConfig._TYPE.LOADING_TARGET]) // 如果设置了targer,使用设置的target,比如el-table
    LoadUtil.showLoading()
  }
  // logger.info('_IS_SHOW_TIP', _IS_SHOW_TIP+'')
  if (config[HttpConfig._TYPE.TIP] !== true) {
    _IS_SHOW_TIP = config[HttpConfig._TYPE.TIP]
  }
  // logger.info('_IS_SHOW_TIP', _IS_SHOW_TIP +'')
  // console.log('initConfig', config)
  return config
}

let onError = (error) => {
  // logger.info('error-config', error.config)
  if (error) {
    // hideLoading()
    LoadUtil.hideLoading()
  }
  if (isShowLogger) logger.error('onError-error', error)
  if (isShowLogger) logger.error('onError-error.toString', error.toString())
  let result = {
    code: HttpCode._OTHER,
    message: '',
    [HttpConfig._TYPE.TIP]: _IS_SHOW_TIP
  }
  if (error.toString().indexOf('400') >= 0) {
    result.code = HttpCode._400
    result.message = '失败（400）：客户端错误！'
  } else if (error.toString().indexOf('403') >= 0) {
    result.code = HttpCode._403
    result.message = '失败（403）：您的权限不足！'
  } else if (error.toString().indexOf('404') >= 0) {
    result.code = HttpCode._404
    result.message = '失败（404）：网络请求不存在！'
  } else if (error.toString().indexOf('500') >= 0) {
    result.code = HttpCode._500
    result.message = '失败（500）：服务器异常！'
  } else if (error.toString().indexOf('501') >= 0) {
    result.code = HttpCode._501
    result.message = '失败（501）：您的操作被取消或不允许提交！'
  } else if (error.toString().indexOf('timeout') >= 0) {
    result.code = HttpCode._TIMEOUT
    result.message = '请求超时，请检查网络连接!'
  } else if (error.toString().indexOf('Cancel') >= 0) {
    result.code = HttpCode._CANCLE
    result.message = '取消请求成功！'
  } else {// 其他未知异常
    result.code = HttpCode._OTHER
    result.message = '未知错误：' + error.toString()
  }
  let errorMsg = error + '-------' + result.message
  // Promise.reject(new Error(errorMsg))
  if (isShowLogger) logger.error(errorMsg)

  return result
}

let onResponse = (response) => {
  if (!response) return
  if (response.headers && response.headers.token) localStorage.setItem(ACCESS_TOKEN, response.headers.token)
  if (response.config && response.config.loading !== false) LoadUtil.hideLoading()
  // hideLoading(response.config.loadingTarget)

  // logger.info('response-config', response.config)

  if (response.data && response.data.code >= 0) {
    let status = response.data.code
    let message = response.data.message
    response.data[HttpConfig._TYPE.TIP] = response.config[HttpConfig._TYPE.TIP]
    if (status === HttpCode._0) {
      response.data.code = 200
    } else if (status === HttpCode._200_S || status === HttpCode._200) {
      // return response.data
    } else if (status === HttpCode._401) {
      response.data.message = message === '未登录' ? '登陆超时,请重新登录!' : message
    } else {
      response.data.message = '未知异常：' + message
    }
    return response.data
  } else {
    return response
  }
}


// request 请求拦截器
common.interceptors.request.use(
  config => {
    config = initConfig(config)
    return config
  }, onError)
// response 响应拦截器
common.interceptors.response.use(onResponse, onError)

instance.interceptors.request.use(
  config => {
    config = initConfig(config)
    return config
  }, onError)
instance.interceptors.response.use(onResponse, onError)

json.interceptors.request.use(
  config => {
    config.headers[CommonContentType._CONTENT_TYPE_KEY] = CommonContentType._APPLICATION.JSON
    config = initConfig(config)
    return config
  }, onError)
json.interceptors.response.use(onResponse, onError)

var resTimer

let handleError = (response) => {
  if (!response) return
  let code = response.code
  let message = response.message
  let type = 'error'
  switch (code) {
    case HttpCode._401:
      if (resTimer) clearTimeout(resTimer)
      resTimer = setTimeout(() => {
        // hideLoading()
        LoadUtil.hideLoading()
        MessageBox.confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'screenSave',
          closeOnPressEscape: false,
          closeOnClickModal: false,
          showCancelButton: false,
          showClose: false,
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('token')
          localStorage.removeItem('userToken')
          localStorage.removeItem('appToken')
          router.replace('/Login')
          // TODO 线上退出登录线上地址更改
          // location.href = "https://login.iam.com/apphub/logout";
        }).catch(() => {
        })
      }, 500)
      break
    case HttpCode._CANCLE:
      type = 'info'
      break
  }

  showTip(response, message, type)
}

let showTip = (response, message, type) => {
  if (response[HttpConfig._TYPE.TIP] === true) {
    Message({
      message: message,
      type: type
    })
  }
}

let parseResponse = (resolve, reject, response) => {
  if (response && (response.code === 200 || response.code === 0 || response.code === '200' || response.code === '0')) {
    resolve(response)
    showTip(response, '成功！', 'success')
  } else {
    handleError(response)
    resolve(response)
  }
}

export default {
  /**
   * 封装get方法
   */
  get(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      let condition = config
      condition.params = data
      common
        .get(url, condition)
        .then(response => {
          if (isShowLogger) logger.net(data, url, response)
          parseResponse(resolve, reject, response)
        })
        .catch(err => {
          Promise.reject(err)
        })
    })
  },

  /**
   * 封装post请求
   */
  post(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      common.post(url, qs.stringify(data), config)
        .then(response => {
          if (isShowLogger) logger.net(data, url, response)
          parseResponse(resolve, reject, response)
        })
        .catch(err => {
          Promise.reject(err)
        })
    })
  },

  /**
   * 封装post请求  multipart/form-data
   */
  postform(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      instance.post(url, data, config).then(response => {
        if (isShowLogger) logger.net(data, url, response)
        parseResponse(resolve, reject, response)
      })
    }).catch(err => {
      Promise.reject(err)
    })
  },

  /**
   * 封装post请求 文件下载
   */
  postdown(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      down.post(url, data, config).then(response => {
        if (isShowLogger) logger.net(data, url, response)
        parseResponse(resolve, reject, response)
      })
    }).catch(err => {
      Promise.reject(err)
    })
  },


  /**
   * 封装post请求 json格式
   */
  postJson(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      json.post(url, data, config).then(response => {
        if (isShowLogger) logger.net(data, url, response)
        parseResponse(resolve, reject, response)
      })
    }).catch(err => {
      Promise.reject(err)
    })
  },

  /**
   * Description: 取消网络请求
   * @author: lhc
   * @date: 2022/1/7 19:55
   */
  cancel(id = HttpConfig._TYPE.CANCLE_DEFAULT) {// 取消当前网络请求
    if (window._axiosPromiseArr) {
      let ele
      for (var i = 0; i < window._axiosPromiseArr.length; i++) {
        ele = window._axiosPromiseArr[i]
        if (id !== HttpConfig._TYPE.CANCLE_DEFAULT) {
          if (ele && id === ele.key && ele.cancle) {
            ele.cancle()
            delete window._axiosPromiseArr[i]
          }
        } else {
          if (ele && id === ele.key && ele.cancle) {
            ele.cancle()
            delete window._axiosPromiseArr[i]
          }
        }
      }
    }
  },

  // closeTip(params = {}) { // 关闭提示
  //   params[HttpConfig._TYPE.TIP] = false
  //   return params
  // },
  //
  // closeLoad(params = {}) {  // 关闭加载进度
  //   params[HttpConfig._TYPE.LOADING] = false
  //   return params
  // },
  //
  // setId(id = HttpConfig._TYPE.CANCLE_DEFAULT) {
  //   let params = {
  //     [HttpConfig._TYPE.CANCLE_KEY]: id
  //   }
  //   return params
  // },

  // get, post, postform, postdown, postJson
}
